import workflowsApi from './api';

export default [workflowsApi()];
